<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <div class="md-layout-item">
      <ElasticList :list="list"></ElasticList>
    </div>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import searchConfig from '@/searchConfig';

  export default {
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "people",
          pageTitle: "People",
          pageIcon: "person",
          linkRows: true,
          listQueryId: "searchPersons",
          deleteQueryId: "deletePerson",
          deleteRelatedRecord: {
            record: [
              { deleteSyncQueryId: "deletePersonAccount", relatedModelItem: 'accounts' },
              { deleteSyncQueryId: "deletePersonCompany", relatedModelItem: 'companys',}
            ]
          },
          deleteMessageNameFields: ['given_name', 'family_name'],
          columns: {
            given_name: { label: "First Name", sortable: true },
            family_name: { label: "Last Name", sortable: true },
            phone_mobile: { label: "Mobile", sortable: true },
            phone_number: { label: "Main Phone", sortable: true },
            email: { label: "Email", sortable: true },
            ssn: { label: "SSN", sortable: true },
            dob: { label: "Birth Date", sortable: true },
            createdAt: { label: "Created", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchPersons && data.searchPersons.items.length) {
              this.$c.log('formatResponse data', data.searchPersons.items);
              data.searchPersons.items.forEach((item) => {                               
                if(item.ssn){
                  item.ssn = item.ssn.replace(/.(?=.{4})/g, 'X');
                }              
                result.push(item);
              })
            }
            return result;
          },
        },
      };
    },
  };
</script>

<style></style>
